import React from 'react';
import classNames from 'classnames';

import styles from './IconBadge.module.scss';

export const iconBadgeSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
};

export const iconBadgeShapes = {
  square: 'square',
  circle: 'circle',
};

export const IconBadgeComponent = ({
  icon,
  bg = 'gray-100',
  size = iconBadgeSizes.md,
  shape = iconBadgeShapes.square,
  className,
}) => (
  <span
    className={classNames(
      styles.iconBadge,
      {
        [styles[`iconBadge_size_${size}`]]: size,
        [styles.iconBadge_shape_circle]: shape === iconBadgeShapes.circle,
      },
      className
    )}
    style={{ background: `var(--${bg})` }}
  >
    {icon}
  </span>
);

IconBadgeComponent.displayName = 'IconBadge';
